import { makeStyles } from '@mui/styles';

import ContentWrapper from '@classify/react-core-components/ContentWrapper';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    borderTop: `1px solid ${palette.divider}`,
  },
}));

function ClassicFooterContainer({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ContentWrapper>{children}</ContentWrapper>
    </div>
  );
}

export default ClassicFooterContainer;
